<template>
  <div class="title-two-warp wh-flex-center">
    <span class="title-txt">{{ title }}</span>
  </div>
</template>

<script>
export default {
  name: 'TitleTwo',
  props: {
    title: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="less" scoped>
  .title-txt{
    padding: 0 20px;
    color: #fff;
    font-size: 20px;
    position: relative;
    &:before{
      content: '';
      width: 30px;
      height: 1px;
      background-image: linear-gradient(to right, #2085E4, #35E8CE);
      position: absolute;
      top: 50%;
      left: 0;
      transform: translate(-100%, -50%);
    }
    &:after{
      content: '';
      width: 30px;
      height: 1px;
      background-image: linear-gradient(to right, #35E8CE, #2085E4);
      position: absolute;
      top: 50%;
      right: 0;
      transform: translate(100%, -50%);
    }
  }
</style>
